<template lang="pug">
  SspLayout.trace(area="tnt")
    template(slot="actions")
      transition(name="fade")
      form.search.input-group(@submit.prevent="$router.push({ name: 'traceDetails', params: { code: code } })")
        input.form-control.code-filter-input(v-model="code" placeholder="Enter Code")
        span.input-group-btn
          SspActionButton.search-for-code-button(type="submit" :spinning="loading" buttonType="default" :disabled="!isValid" text="" icon="search")
      div.pl10(v-if="self")
        SspActionButton(@onClick="fetchData()" buttonType="default" icon="refresh" text="" :spinning="loading")
        router-link.btn.btn-default(:to="{ name: 'traceMap', params: { code: cleanCode } }")
          i.fa.fa-map-marker
          span.ml5 Map
        button.btn.btn-default(@click="$refs.recallCodeModal.open()")
          i.fa.fa-rotate-left
          span.ml5 Recall

    .row
      .col-sm-9
        CodeDetails(v-if="lastEvent" :lastEvent="lastEvent" :shipment="shipment")
        EventDetails(v-if="events" :events="events")
      .col-sm-3(v-if="package")
        PackageDetails(:package="package" :product="product")
        ShipmentDetails(:shipment="shipment")
        HierarchyDetails(:self="self" :parent="parent")

    RecallCodeModal(ref="recallCodeModal" v-if="self" :code="self.code")
</template>

<script>
import TrackNTrace from '@/service/apis/TrackNTrace'
import Util from '@/service/Util'
import EventDetails from './components/EventDetails'
import PackageDetails from './components/PackageDetails'
import ShipmentDetails from './components/ShipmentDetails'
import CodeDetails from './components/CodeDetails'
import HierarchyDetails from './components/HierarchyDetails'
import RecallCodeModal from './components/RecallCodeModal'

export default {
  data: () => ({
    code: null,
    shipment: null,
    events: null,
    lastEvent: null,
    package: null,
    product: null,
    self: null,
    parent: null,
    loading: false
  }),
  mounted() {
    if (!this.$route.params.code) {
      this.$el.querySelector('.code-filter-input').focus()
    }
  },
  created() {
    if (this.$route.params.code) {
      this.code = this.$route.params.code
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      TrackNTrace.traceCode(this.cleanCode)
        .then((resp) => {
          this.events = resp.data.events.event
          const [lastEvent] = resp.data.events.event
          this.lastEvent = lastEvent
          this.package = resp.data.package
          this.product = resp.data.product
          this.self = resp.data.self
          this.parent = resp.data.parent
        })
        .then(() => {
          TrackNTrace.findShipmentByCode(this.cleanCode)
            .then((resp) => {
              this.shipment = resp.data
            })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.loading = false
        })
    }
  },
  watch: {
    $route() {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.fetchData()
      }
    },
    code() {
      this.searchError = null
    }
  },
  computed: {
    cleanCode() {
      return Util.sanitizeCode(this.code)
    },
    isValid() {
      return this.code
    }
  },
  components: {
    EventDetails,
    PackageDetails,
    ShipmentDetails,
    CodeDetails,
    HierarchyDetails,
    RecallCodeModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/Trace.vue